module.exports = __webpack_public_path__ + "static/media/sm1-banner.817d418d.jpeg";